import { render, staticRenderFns } from "./Model24.vue?vue&type=template&id=0aef2576&scoped=true"
import script from "./Model24.vue?vue&type=script&lang=js"
export * from "./Model24.vue?vue&type=script&lang=js"
import style0 from "./Model24.vue?vue&type=style&index=0&id=0aef2576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aef2576",
  null
  
)

export default component.exports